import React, { useRef } from "react";
import { get } from 'lodash';
import { CSSTransition } from 'react-transition-group';

import Link from "../../../components/Link";
import Text from "../../../components/Text";
import FeaturedArticle from "./FeaturedArticle";

import style from './style.module.css';

export default function MegaMenu({ megaMenu = [], resetActive = () => { }, activeId, megaMenuId, type = "desktop" }) {

    const nodeRef = useRef(null);

    if (type === "desktop") {
        return (
            <CSSTransition
                in={activeId === megaMenuId ? true : false}
                timeout={300}
                classNames="item"
                className={style.megaMenu}
                nodeRef={nodeRef}
                unmountOnExit
            >
                <div className={style.c}>
                    <div className={style.c}>
                        <div className={`${style.megaMenuRow}`}>
                            <div className={`${style.megaMenuLeftColumn} ${get(megaMenu, "featured_article", []).length > 0 ? style.featuredYes : ''}`}>
                                <div className={`${style.megaMenuLeftColumnRow}`}>
                                    {
                                        megaMenu.menu_type === "mega_menu" && (
                                            megaMenu.mega_menu.map((megaMenu, mindex) => {
                                                return (
                                                    <div className={`${style.megaMenuColumn} ${style[`megaMenuColumnCol${megaMenu.length > 4 ? 4 : megaMenu.length}`]}`} key={`megaMenuColumn_${mindex}_${megaMenu.label}`}>
                                                        <div className={style.megaMenuListColumnInner}>
                                                            <div className={style.megaMenuHeader}>
                                                                <Text className={"megaMenuTitle"} text={megaMenu.label} />
                                                            </div>
                                                            <div className={style.megaBody}>
                                                                {
                                                                    megaMenu.links.map((menu, menuIndex) => (
                                                                        <Link
                                                                            onClick={resetActive}
                                                                            className={style.megaMenuItem}
                                                                            to={menu.url}
                                                                            key={`megaMenuLink_${mindex}_${menuIndex}_${menu.label}}`}
                                                                        >
                                                                            {menu.label}
                                                                        </Link>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    }
                                </div>
                                {
                                    (
                                        megaMenu.menu_type === "mega_menu" && get(megaMenu, "featured_article", []).length > 0 &&
                                        <FeaturedArticle
                                            featuredList={megaMenu.featured_article}
                                            buttonLabel={megaMenu.button_label}
                                            buttonLink={megaMenu.button_url}
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        )
    } else if (type === "mobile") {
        return (
            megaMenu.length > 0 && megaMenu.map((megaMenu, index) => {
                return (
                    <div className={`${style.mobileMegaMenuColumn}`} key={`mobileMegaMenuColumn_${index}_${megaMenu.label}`}>
                        <div className={style.mobileMegaMenuListColumnInner}>
                            <div className={style.mobileMegaMenuHeader}>
                                <Text className="megaMenuTitle" text={megaMenu.label} />
                            </div>
                            <div className={style.mobileMegaBody}>
                                {
                                    megaMenu.links.map((menu, menuIndex) => (
                                        <Link className={style.mobileMegaMenuItem} to={menu.url} key={`mobikleMegaMenuItem_${menuIndex}_${menu.label}`}>
                                            {menu.label}
                                        </Link>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )
            })
        )
    } else {
        return null;
    }
}